import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { getTerms } from "../../api/legal";

export default function Terms() {
  return <LegalDocumentPage fetcher={getTerms} fallbackTitle="Termos de Uso" />;
}
